module.exports = __webpack_public_path__ + "static/media/Digital Communication Engineering.9b323014.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ECE/Digital Communication Engineering.pdf
// module id = 112
// module chunks = 0